// extracted by mini-css-extract-plugin
export default {"tab":"tab_tab__2UQID","tab_type_current":"tab_tab_type_current__Q2VnC"};